setUserLocalData